var map = {
	".": [
		92
	],
	"./": [
		92
	],
	"./business-continuity-plan": [
		191,
		2
	],
	"./business-continuity-plan/": [
		191,
		2
	],
	"./business-continuity-plan/index": [
		191,
		2
	],
	"./business-continuity-plan/index.js": [
		191,
		2
	],
	"./index": [
		92
	],
	"./index.css": [
		409
	],
	"./index.js": [
		92
	],
	"./privacy-policy": [
		192,
		1
	],
	"./privacy-policy/": [
		192,
		1
	],
	"./privacy-policy/index": [
		192,
		1
	],
	"./privacy-policy/index.js": [
		192,
		1
	],
	"./terms-of-use": [
		193,
		0
	],
	"./terms-of-use/": [
		193,
		0
	],
	"./terms-of-use/index": [
		193,
		0
	],
	"./terms-of-use/index.js": [
		193,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 885;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/SimplePages lazy ^\..*$
// module id = 885
// module chunks = 3